import { render, staticRenderFns } from "./Edit-Saved-War.vue?vue&type=template&id=1883525e"
import script from "./Edit-Saved-War.vue?vue&type=script&lang=js"
export * from "./Edit-Saved-War.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports